import { configurationApi } from '../configurationApi';
import { RoomType } from '../types/roomType';

const roomEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    getRooms: builder.query<RoomType[], { centerId: string }>({
      query: ({ centerId }) => `/rooms?centerId=${encodeURIComponent(centerId)}`,
      providesTags: ['Rooms'],
    }),

    upsertRoom: builder.mutation<RoomType, RoomType>({
      query: (room) => ({
        url: '/room',
        method: 'POST',
        body: room,
      }),
      invalidatesTags: ['Rooms'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetRoomsQuery, useUpsertRoomMutation } = roomEndpoints;
